import _defineProperty from '@babel/runtime-corejs2/helpers/defineProperty';
import { forwardRef } from 'react';
import Tooltip from '@locus-labs/mol-desktop-tooltip';
import Box from '@locus-labs/mol-desktop-box';
import MapNavButton from '@locus-labs/mol-desktop-map-nav-button';
import PropTypes from 'prop-types';
import styledSystemPropTypes from '@styled-system/prop-types';
import omit from 'lodash.omit';
import { jsxs, jsx } from 'react/jsx-runtime';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const ZoomControl = /*#__PURE__*/forwardRef((props, ref) => {
  const omitedProps = omit(props, ['onZoomIn', 'onZoomOut']);
  const zoomIn = () => {
    props.onZoomIn();
  };
  const zoomOut = () => {
    props.onZoomOut();
  };
  return /*#__PURE__*/jsxs(Box, _objectSpread(_objectSpread({
    boxShadow: "md",
    borderRadius: "lg",
    display: "inline-block",
    ref: ref
  }, omitedProps), {}, {
    children: [/*#__PURE__*/jsx(Box, {
      width: "30px",
      height: "30px",
      children: /*#__PURE__*/jsx(Tooltip, {
        content: props.zoomInTooltipContent,
        children: /*#__PURE__*/jsx(MapNavButton, {
          onClick: zoomIn,
          iconName: "zoom.in",
          boxShadow: "none",
          borderBottomLeftRadius: "0",
          borderBottomRightRadius: "0",
          ariaLabel: props.zoomInTooltipContent
        })
      })
    }), /*#__PURE__*/jsx(Box, {
      width: "30px",
      height: "30px",
      children: /*#__PURE__*/jsx(Tooltip, {
        content: props.zoomOutTooltipContent,
        children: /*#__PURE__*/jsx(MapNavButton, {
          onClick: zoomOut,
          iconName: "zoom.out",
          boxShadow: "none",
          borderTopLeftRadius: "0",
          borderTopRightRadius: "0",
          ariaLabel: props.zoomOutTooltipContent
        })
      })
    })]
  }));
});
ZoomControl.displayName = 'Zoom Control';
ZoomControl.defaultProps = {
  'data-cy': 'ZoomControl',
  // component name
  zoomOutTooltipContent: 'Zoom Out',
  zoomInTooltipContent: 'Zoom In'
};
ZoomControl.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, styledSystemPropTypes.space), styledSystemPropTypes.color), styledSystemPropTypes.background), styledSystemPropTypes.border), styledSystemPropTypes.flexbox), styledSystemPropTypes.grid), styledSystemPropTypes.layout), styledSystemPropTypes.position), styledSystemPropTypes.shadow), styledSystemPropTypes.typography), {}, {
  as: PropTypes.string,
  forwardAs: PropTypes.string,
  onZoomOut: PropTypes.func.isRequired,
  onZoomIn: PropTypes.func.isRequired,
  zoomOutTooltipContent: PropTypes.string,
  zoomInTooltipContent: PropTypes.string,
  tooltipZIndex: PropTypes.number
});

export default ZoomControl;
